import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { EstimateDataBuilder } from './estimate-data.builder';
import { EstimateDataService } from './estimate-data.service';
import { EstimateDataEffects } from './estimate-data.effects';
import { FEATURE_NAME, reducer } from './estimate-data.reducer';
import { EstimateDataDispatcher } from './estimate-data.dispatcher';
import { EstimateDataStore } from './estimate-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([EstimateDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class EstimateDataModule {
  static forRoot(): ModuleWithProviders<EstimateDataModule> {
    return {
      ngModule: EstimateDataModule,
      providers: [
        EstimateDataBuilder,
        EstimateDataService,
        EstimateDataDispatcher,
        EstimateDataStore,
      ],
    };
  }
}
